import React from "react";
import HomeCard from "./homeCard";
import { ScorecardQA } from "./cardScorecardQAData";
import PopUpFormDownloadScorecard from "../../../popUpForms/popUpFormDownloadScorecard";

const icons = [
  {
    title: "Windows",
    aria: "Download button for zip file extraction tool for windows operating system",
    icon: "fa-windows",
  },
  {
    title: "Mac",
    aria: "Download button for zip file extraction tool for Mac operating system",
    icon: "fa-apple",
  },
  {
    title: "Linux",
    aria: "Download button for zip file extraction tool for Linux operating system",
    icon: "fa-linux",
  },
];

const CardScorecardOverview = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="download"
      title="Scorecard Overview "
      titleColor="var(--cornflower-blue)"
      image="./images/home/card-scorecard-details.png"
      popUpComponent={<PopUpFormDownloadScorecard />}
      content={[
        { type: "accordion", data: ScorecardQA },
        {
          type: "button",
          text: "Download Scorecard",
          color: "var(--cornflower-blue)",
        },
        {
          type: "bottom-paragraph",
          text: "Need a zip file extraction tool?",
          color: "var(--white)",
        },
        { type: "icons", icons: icons },
        {
          type: "bottom-paragraph",
          text: "Problems Downloading? <a href='/contact-us'>Contact Us</a>",
          color: "var(--white)",
        },
      ]}
    />
  );
};

export default CardScorecardOverview;
